module.exports = __webpack_public_path__ + "static/media/battery-level-90-charging.a5d50b9d.svg";